import React from 'react'

interface Column<T> {
    key: keyof T | string
    title: string
    render?: (item: T) => React.ReactNode
    className?: string
}

interface TableProps<T> {
    columns: Column<T>[]
    data: T[]
    loading?: boolean
    emptyMessage?: string
    onRowClick?: (item: T) => void
}

function Table<T extends {id?: string | number}>({
    columns,
    data,
    loading = false,
    emptyMessage = 'لا توجد بيانات',
    onRowClick
}: TableProps<T>) {
    if (loading) {
        return (
            <div className="text-center py-12">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                <p className="mt-2 text-gray-500">جاري التحميل...</p>
            </div>
        )
    }

    if (!data.length) {
        return (
            <div className="text-center py-12">
                <p className="text-gray-500">{emptyMessage}</p>
            </div>
        )
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        {columns.map((column) => (
                            <th
                                key={column.key as string}
                                className={`px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider ${column.className || ''}`}
                            >
                                {column.title}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item, index) => {
                        // ✅ المفتاح يعتمد على is_active إذا كان موجود
                        const itemAny = item as any
                        const key = itemAny.is_active !== undefined
                            ? `${item.id || index}-${itemAny.is_active}`
                            : item.id || index

                        return (
                            <tr
                                key={key}
                                onClick={() => onRowClick?.(item)}
                                className={onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}
                            >
                                {columns.map((column) => (
                                    <td
                                        key={column.key as string}
                                        className={`px-6 py-4 whitespace-nowrap text-sm text-gray-900 ${column.className || ''}`}
                                    >
                                        {column.render
                                            ? column.render(item)
                                            : (item[column.key as keyof T] as React.ReactNode)}
                                    </td>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default Table